export default {"src":"__ASTRO_ASSET_IMAGE__BvV0CRVf__","width":686,"height":256,"format":"jpg"}